import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Search, MapPinned, HandshakeIcon, Shield, Sprout, Sparkles } from 'lucide-react';

export default function HowItWorks() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Come funziona</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter max-w-3xl">
        Semplice. Reale. Verificabile.
      </h1>
      <p className="mt-6 text-muted-foreground max-w-2xl">
        AgriNexus è progettato attorno a un principio: <b>ogni informazione mostrata proviene da dati reali</b>. Nessun numero inventato. Nessun terreno finto. Nessuna recensione simulata.
      </p>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {[
          { I: Search, t: '1 · Cerca', d: 'Filtra terreni per zona, superficie, prezzo e caratteristiche. Ogni annuncio è geolocalizzato sulla mappa.' },
          { I: MapPinned, t: '2 · Trova', d: 'Apri la scheda completa: galleria, mappa, caratteristiche, colture compatibili e stato dell’annuncio.' },
          { I: HandshakeIcon, t: '3 · Connettiti', d: 'Contatta il proprietario direttamente dalla piattaforma. I tuoi dati personali restano privati.' },
        ].map((s,i)=>(
          <div key={i} className="rounded-2xl border border-border p-8">
            <s.I size={28} strokeWidth={1.4}/>
            <h3 className="mt-6 font-display text-2xl">{s.t}</h3>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-24 grid md:grid-cols-2 gap-10">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Matching</div>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight">Un punteggio trasparente.</h2>
          <p className="mt-4 text-muted-foreground max-w-lg">Ogni terreno riceve un punteggio di compatibilità con le tue preferenze. Il calcolo è basato su regole verificabili: zona, budget, superficie, colture e caratteristiche richieste. Nessuna scatola nera.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Sicurezza</div>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight">Privacy prima di tutto.</h2>
          <p className="mt-4 text-muted-foreground max-w-lg">La posizione esatta del proprietario non viene mai mostrata pubblicamente. Email e telefono restano privati fino a quando non decidi tu di condividerli.</p>
        </div>
      </div>

      <div className="mt-24 rounded-3xl bg-foreground text-background p-10 md:p-16">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-accent mb-3">Ecosistema futuro</div>
        <h2 className="font-display text-3xl md:text-5xl tracking-tighter max-w-2xl">Un giorno, tutto l’agri in un solo posto.</h2>
        <div className="mt-8 grid md:grid-cols-4 gap-4 text-sm">
          {['Professionisti', 'Macchinari', 'Servizi', 'Finanziamenti'].map(x => (
            <div key={x} className="rounded-2xl border border-background/20 p-5">
              <div className="opacity-60 text-[10px] uppercase tracking-widest">Prossimamente</div>
              <div className="mt-2 font-display text-xl">{x}</div>
            </div>
          ))}
        </div>
        <Link to="/registrati"><Button className="mt-10 rounded-full bg-accent text-accent-foreground hover:bg-accent/90">Registrati adesso <ArrowRight size={16} className="ml-2"/></Button></Link>
      </div>
    </div>
  );
}
